module.exports = __webpack_public_path__ + "static/img/471x463.358c37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/471x463.png
// module id = cILF
// module chunks = 0